import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { checkIsAgent, checkIsProfileChecker, checkIsYp } from "shared-auth";
import { UserClaimTypes, UserManager } from "core";
import { NOT_FOUND_FULL_PATH, VIEW_PIN_PATTERN } from "app/config/routes";

export function contactsRestrictionLoader() {
  if (checkIsAgent()) {
    throw new Response("Not Found", { status: 404 });
  }

  return null;
}

export function agenciesHelpPageRestrictionLoader() {
  if (checkIsYp()) {
    return null;
  }

  throw new Response("Not Found", { status: 404 });
}

export function socialMediaPageRestrictionLoader() {
  if (checkIsProfileChecker()) {
    return null;
  }

  throw new Response("Not Found", { status: 404 });
}

export function viewPinRedirectPageLoader() {
  const viewPin = UserManager.getClaim(UserClaimTypes.viewPin);

  return redirect(viewPin ? `/${viewPin}` : NOT_FOUND_FULL_PATH);
}

export function basePathLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const match = VIEW_PIN_PATTERN.exec(url.pathname);

  if (match) {
    return redirect(`/${match[0]}`);
  }

  throw new Response("Not Found", { status: 404 });
}

export function viewPinPageLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);

  if (VIEW_PIN_PATTERN.test(url.pathname)) {
    return null;
  }

  throw new Response("Not Found", { status: 404 });
}
